import React from "react";
import { MANIFESTO } from "@/data/mock";
import { FadeUp } from "@/components/shared/RevealText";

export default function Manifesto() {
    return (
        <section className="relative border-t border-ink/10 bg-slate-25 py-24 md:py-32" data-testid="manifesto-section">
            <div className="container-x">
                <div className="mb-16 grid grid-cols-1 items-end gap-8 md:grid-cols-12">
                    <FadeUp className="md:col-span-6">
                        <div className="eyebrow mb-4">Ch. 02 · Manifesto</div>
                        <h2 className="h-display font-display text-[40px] font-black leading-[0.95] text-ink md:text-[64px]">
                            Why this
                            <br />
                            <span className="serif-italic text-pink">platform</span> exists.
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.1} className="md:col-span-6">
                        <p className="max-w-xl text-[16px] leading-relaxed text-slate-600 md:text-[17px]">
                            Four commitments. Each one deliberately chosen to remove friction between the person filing
                            a request and the person accountable for its outcome.
                        </p>
                    </FadeUp>
                </div>

                <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
                    {MANIFESTO.map((m, i) => (
                        <FadeUp key={m.n} delay={i * 0.08}>
                            <article className="group relative flex h-full flex-col rounded-[24px] border border-ink/10 bg-white p-8 transition-colors duration-500 hover:border-ink/20 md:p-12">
                                <div className="pointer-events-none absolute right-8 top-6 text-[110px] font-black italic leading-none text-pink/20 md:right-10 md:top-6 md:text-[160px]" style={{ fontFamily: "Playfair Display" }}>
                                    {m.n}
                                </div>
                                <div className="relative">
                                    <div className="eyebrow mb-4">Chapter {m.n}</div>
                                    <h3 className="font-display text-[28px] font-semibold tracking-tight text-ink md:text-[36px]">
                                        {m.title}
                                    </h3>
                                    <p className="mt-4 max-w-md text-[15px] leading-relaxed text-slate-600 md:text-[16px]">
                                        {m.body}
                                    </p>
                                </div>
                                <div className="mt-10 h-px w-full bg-ink/10" />
                                <div className="mt-4 flex items-center justify-between text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-500">
                                    <span>Principle</span>
                                    <span>Non-negotiable</span>
                                </div>
                            </article>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
